import type { LabelValue } from "newui/types/LabelValue.type";
import type { CommonLookupResponse } from "newui/store/tanstack-base";
import { useCommonLookup } from "newui/store/tanstack-base";
import { fetchSpecialities } from "../company-api";

export const useSpecialities = (): CommonLookupResponse<LabelValue<number>> =>
	useCommonLookup<LabelValue<number>>("specialities", fetchSpecialities);
